import * as React from 'react';
const { useState, useEffect, useCallback } = React;
import {
	withRouter,
	RouteComponentProps,
} from 'react-router-dom';
import { BaseRoute } from '@seeneco-ui/core/models/routing';

import { Integrations } from '../../../../integrations';
import ContactData from '../contact-data';
import PayeeRequsites from '../payee-requisites';
import DeveloperZone from '../developer-zone';
import XTenantAccountEntry from './entry.view';


type TenantAccountEntryProps = {} & RouteComponentProps<any>;

const TenantAccountEntry: React.SFC<TenantAccountEntryProps> = (props) => {
	const {
		history,
		location,
	} = props;
	const [path, setPath] = useState(routes[0].path);

	useEffect(() => {
		const [path] = location.pathname.split('/').reverse();
		const hasRoute = Boolean(getRoutes().find(x => x.path === path));

		hasRoute && setPath(path);
	}, []);

	const handleChangePath = useCallback((path: string) => {
		const splittedPath = path.split('/');

		setPath(splittedPath[splittedPath.length - 1]);
		history.push(path);
	}, []);

	return (
		<XTenantAccountEntry
			{...props}
			path={path}
			routes={getRoutes()}
			onChangePath={handleChangePath}
		/>
	);
}

TenantAccountEntry.displayName = 'TenantAccountEntry[Container]';
TenantAccountEntry.defaultProps = {};

const routes: Array<BaseRoute> = [
	{
		path: 'contact-data',
		name: 'Контактные данные',
		component: ContactData,
	},
	{
		path: 'payee-requisites',
		name: 'Реквизиты плательщика',
		component: PayeeRequsites,
	},
	{
		path: 'bills-and-services',
		name: 'Счета и услуги',
		component: () => <div>Счета и услуги</div>,
	},
	{
		path: 'integrations',
		name: 'Интеграции',
		component: Integrations,
	},
	{
		path: 'developer-zone',
		name: 'Разработчикам',
		component: DeveloperZone,
	},
	{
		path: 'settings',
		name: 'Настройки',
		component: () => <div></div>,
	},
];

function getRoutes(): Array<BaseRoute> {
	return routes;
}

export default withRouter(TenantAccountEntry);
